import { CHANNELS_FAVORITE_ID } from '../../constants/smallPieces';

export const isChannelItemInFavorite = (channelItem, favoriteCode = CHANNELS_FAVORITE_ID) => (
  channelItem.channels_categories?.some(categoryId => categoryId === favoriteCode)
) ? true : false;
